module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.9037/images/achievement-abstract.svg"